// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto', 'Roboto Fallback'","fontStyle":"normal"},"className":"__className_4f1194","variable":"__variable_4f1194"};